import { ApiService } from '@/features/api';

export type VerifyResponse = {
  status: 'pending' | 'verified';
  valid: boolean;
};

export const phoneVerificationService = {
  /**
   * Sends an SMS to the provided phone number. Phone number must be in E.164 format. Only `+1` is
   * supported.
   * @param phoneNumber The phone number to send the SMS to.
   */
  sendCode: async (phoneNumber: string): Promise<void> =>
    ApiService.post(`${import.meta.env.APP_URLS_API_URL}/v1/users/verification/phone`, {
      body: { phoneNumber },
    }),
  verify: async (code: string, phoneNumber: string): Promise<VerifyResponse> =>
    ApiService.post(
      `${import.meta.env.APP_URLS_API_URL}/v1/users/verification/phone/verificationToken`,
      {
        body: { code, phoneNumber },
      }
    ),
} as const;
